import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'

const namespaceMapper: Record<string, string> = {
  translation: 'hdgw',
  privacyPolicy: 'privacy-policy'
}

const languageMap: Record<string, string> = {
  'en-US': 'en',
  'en-GB': 'en',
  'es-MX': 'es-419'
}

i18n
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./data/${languageMap[language] ?? language}/${namespaceMapper[namespace]}.json`)
    )
  )
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false
    },
    // languages taken from folders
    supportedLngs: [
      'cs-CZ',
      'da-DK',
      'de-CH',
      'de-DE',
      'en-US',
      'en-GB',
      'es-MX',
      'es-ES',
      'fil-PH',
      'fr-CA',
      'fr-FR',
      'hu-HU',
      'id-ID',
      'it-IT',
      'ja-JP',
      'ko-KR',
      'ms-MY',
      'nl-NL',
      'pl-PL',
      'pt-BR',
      'ro-RO',
      'sv-SE',
      'th-TH',
      'tr-TR',
      'vi-VN'
    ],
    defaultNS: 'translation',
    ns: ['translation', 'privacyPolicy'],
    returnEmptyString: false
  })

// eslint-disable-next-line import/no-default-export
export default i18n
